module.exports = __webpack_public_path__ + "static/media/ge-logo.005212f2.png";